import React from 'react';
import { Link } from 'react-router-dom';

const Confidentialite: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <header className="border-b border-gray-100 px-6 py-4">
        <div className="max-w-3xl mx-auto flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="Aglomera" className="w-8 h-8 rounded-xl object-contain" style={{ background: '#e6edfa', padding: '4px' }} />
            <span className="font-bold text-lg" style={{ color: '#2a52a8' }}>Aglomera</span>
          </div>
          <Link to="/login" className="text-sm text-gray-500 hover:text-gray-900 transition-colors">← Retour</Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-12">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Politique de confidentialité</h1>
        <p className="text-sm text-gray-400 mb-10">Dernière mise à jour : 5 mai 2025</p>

        <section className="mb-8">
          <h2 className="text-lg font-bold mb-3" style={{ color: '#2a52a8' }}>1. Responsable du traitement</h2>
          <p className="text-gray-700 leading-relaxed">
            Le responsable du traitement des données personnelles collectées via Aglomera est Gabriel Campant, joignable à l'adresse <a href="mailto:contact@aglomera.com" className="hover:underline" style={{ color: '#2a52a8' }}>contact@aglomera.com</a>.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-lg font-bold mb-3" style={{ color: '#2a52a8' }}>2. Données collectées</h2>
          <p className="text-gray-700 leading-relaxed mb-3">
            Dans le cadre de l'utilisation du Service, les données suivantes sont collectées :
          </p>
          <ul className="list-disc list-inside text-gray-700 space-y-1 pl-2">
            <li><strong>Adresse e-mail</strong> : lors de la création du compte, via Google OAuth ou inscription directe</li>
            <li><strong>Profil candidat</strong> : statut, postes visés, secteurs, localisation et autres préférences renseignées volontairement</li>
            <li><strong>Alertes emploi</strong> : critères de recherche configurés par l'utilisateur (mots-clés, type de contrat, plateformes…)</li>
            <li><strong>Favoris</strong> : offres d'emploi mises en favoris par l'utilisateur</li>
            <li><strong>Données techniques</strong> : logs de connexion à des fins de sécurité et de débogage</li>
          </ul>
          <p className="text-gray-700 leading-relaxed mt-3">
            Aucune donnée bancaire n'est stockée sur les serveurs d'Aglomera. Les paiements sont intégralement gérés par Stripe.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-lg font-bold mb-3" style={{ color: '#2a52a8' }}>3. Finalités du traitement</h2>
          <p className="text-gray-700 leading-relaxed mb-3">Les données collectées sont utilisées pour :</p>
          <ul className="list-disc list-inside text-gray-700 space-y-1 pl-2">
            <li>Créer et gérer le compte utilisateur</li>
            <li>Personnaliser les alertes et les newsletters selon le profil candidat</li>
            <li>Envoyer les newsletters thématiques via ForwardEmail</li>
            <li>Gérer les abonnements et les paiements via Stripe</li>
            <li>Assurer la sécurité et prévenir les abus</li>
            <li>Améliorer la qualité du Service</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-lg font-bold mb-3" style={{ color: '#2a52a8' }}>4. Cookies et tracking</h2>
          <p className="text-gray-700 leading-relaxed">
            Aglomera n'utilise <strong>aucun cookie publicitaire, aucun outil de tracking tiers</strong> (Google Analytics, Hotjar, Mixpanel, etc.) et ne revend aucune donnée à des tiers. Seules des données techniques strictement nécessaires au bon fonctionnement du Service (token d'authentification) sont stockées localement dans le navigateur.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-lg font-bold mb-3" style={{ color: '#2a52a8' }}>5. Newsletters et ForwardEmail</h2>
          <p className="text-gray-700 leading-relaxed">
            Les newsletters thématiques sont envoyées via le service ForwardEmail (<a href="https://forwardemail.net" target="_blank" rel="noopener noreferrer" className="hover:underline" style={{ color: '#2a52a8' }}>forwardemail.net</a>). L'adresse e-mail de l'utilisateur est transmise à ce service dans le seul but d'acheminer les emails. ForwardEmail est un service axé sur la confidentialité, n'exploitant pas les données à des fins publicitaires.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-lg font-bold mb-3" style={{ color: '#2a52a8' }}>6. Sous-traitants</h2>
          <p className="text-gray-700 leading-relaxed mb-3">Aglomera fait appel aux sous-traitants suivants :</p>
          <ul className="list-disc list-inside text-gray-700 space-y-1 pl-2">
            <li><strong>Hetzner</strong> — hébergement des serveurs (Allemagne, Union européenne)</li>
            <li><strong>Google Firebase</strong> — authentification des utilisateurs</li>
            <li><strong>ForwardEmail</strong> — envoi des newsletters thématiques</li>
            <li><strong>Stripe</strong> — traitement sécurisé des paiements</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-lg font-bold mb-3" style={{ color: '#2a52a8' }}>7. Localisation des données</h2>
          <p className="text-gray-700 leading-relaxed">
            Les données sont hébergées sur des serveurs situés en Allemagne (Hetzner), au sein de l'Union européenne. Les transferts éventuels hors UE (via Google Firebase ou Stripe) sont encadrés par des mécanismes conformes au RGPD, notamment les clauses contractuelles types de la Commission européenne.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-lg font-bold mb-3" style={{ color: '#2a52a8' }}>8. Durées de conservation</h2>
          <ul className="list-disc list-inside text-gray-700 space-y-1 pl-2">
            <li>Données de compte (email, profil) : conservées jusqu'à la suppression du compte</li>
            <li>Alertes et favoris : conservés pendant toute la durée d'activité du compte</li>
            <li>Logs techniques : conservés 30 jours maximum</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-lg font-bold mb-3" style={{ color: '#2a52a8' }}>9. Sécurité</h2>
          <p className="text-gray-700 leading-relaxed">
            Aglomera met en œuvre des mesures techniques appropriées pour protéger vos données : chiffrement des communications (HTTPS/TLS), authentification sécurisée via Google Firebase, accès restreint à la base de données. En cas d'incident de sécurité, contactez immédiatement <a href="mailto:contact@aglomera.com" className="hover:underline" style={{ color: '#2a52a8' }}>contact@aglomera.com</a>.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-lg font-bold mb-3" style={{ color: '#2a52a8' }}>10. Vos droits RGPD</h2>
          <p className="text-gray-700 leading-relaxed mb-3">
            Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez des droits suivants sur vos données :
          </p>
          <ul className="list-disc list-inside text-gray-700 space-y-1 pl-2">
            <li><strong>Droit d'accès</strong> : obtenir une copie des données vous concernant</li>
            <li><strong>Droit de rectification</strong> : corriger des données inexactes ou incomplètes</li>
            <li><strong>Droit à l'effacement</strong> : demander la suppression de vos données</li>
            <li><strong>Droit à la portabilité</strong> : recevoir vos données dans un format structuré et lisible</li>
            <li><strong>Droit d'opposition</strong> : vous opposer à certains traitements</li>
            <li><strong>Droit à la limitation</strong> : restreindre le traitement dans certains cas</li>
          </ul>
          <p className="text-gray-700 leading-relaxed mt-3">
            Pour exercer ces droits, contactez : <a href="mailto:contact@aglomera.com" className="hover:underline" style={{ color: '#2a52a8' }}>contact@aglomera.com</a>. En cas de réponse insatisfaisante, vous pouvez saisir la <strong>CNIL</strong> (Commission Nationale de l'Informatique et des Libertés) à l'adresse <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="hover:underline" style={{ color: '#2a52a8' }}>www.cnil.fr</a>.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-lg font-bold mb-3" style={{ color: '#2a52a8' }}>11. Modifications de la politique</h2>
          <p className="text-gray-700 leading-relaxed">
            Aglomera se réserve le droit de modifier la présente politique à tout moment. Les utilisateurs seront informés des changements significatifs par email. L'utilisation continue du Service après modification vaut acceptation de la nouvelle politique.
          </p>
        </section>

        <div className="mt-12 pt-8 border-t border-gray-100 text-center text-sm text-gray-400">
          Aglomera — <a href="mailto:contact@aglomera.com" className="hover:underline" style={{ color: '#2a52a8' }}>contact@aglomera.com</a>
        </div>
      </main>
    </div>
  );
};

export default Confidentialite;
